import {IAuth} from '@/modules/Auth/interfaces/auth.interface';

export namespace IRequestAuthRegistration {

  export const ACTION: string = 'registration_create';
  export const ACTION_CONFIRM: string = 'registration_confirm';


  export interface InputParamsToConfirmRegistration {
    guid: string;
  }

  export function convertToInputParamsToConfirmRegistration(registrationConfirm: string): InputParamsToConfirmRegistration {
    return {
      guid: registrationConfirm,
    };
  }

  export function convertToOutputResultToConfirmRegistration(data: any): IAuth.ResourceAuthRegistrationConfirmResponseDataResult {
    return data;
  }
}
